const INFO = {
	main: {
		title: "Aryaman's Portfolio",
		name: "Aryaman Sinha",
		email: "aryaman@vanco.ai",
		logo: "../logo.png",
	},

	socials: {
		twitter: "https://twitter.com/Aryaman1702/",
		github: "https://github.com/AryamanSi17",
		linkedin: "https://www.linkedin.com/in/aryaman-sinha-24792b220/",
	},

	homepage: {
		title: "Full Stack AI Developer",
		description:
			"Full Stack AI Developer with expertise in React.js, Node.js, LangChain, LangGraph, n8n automation, and CrewAI. Skilled in building scalable, secure, and reliable applications while writing clean, high-quality code. Passionate about solving complex problems and continuous learning.",
	},

	about: {
		title: "I live in Bengaluru , where I code amazing things",
		description:
			"Freelance Developer with a strong track record of delivering tailored solutions across domains. Skilled at thriving in fast-paced environments, with proven hackathon success, innovative problem-solving, and a passion for technology. Always open to new ideas and feedback.",
	},

	articles: {
		title: "Demystifying WebAssembly: The Future of Web Development",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
	},

	projects: [
		{
			title: "Nano Prompts",
			description:
				"The world's best prompt library. Discover 10,000+ curated AI prompt presets for Gemini, Nano Banana Pro, and GPT. Free templates for stunning image creation.",
			logo: "https://nanoprompts.space/favicon.ico",
			linkText: "View Project",
			link: "https://nanoprompts.space/",
		},
		{
			title: "GlobalMed Academy",
			description:
				"A healthcare EdTech platform delivering live and recorded medical courses to professionals worldwide. Built a scalable LMS that has empowered 10,000+ learners and generated over ₹10 lakh in business in 3 months.",
			logo: "https://www.globalmedacademy.com/assets/images/logo/logo1.png",
			linkText: "View Project",
			link: "https://www.globalmedacademy.com",
		}
		,
		{
			title: "AI-Powered Serverless WhatsApp Bot",
			description:
				"A multi-step automation bot that processes user media (audio/video) in WhatsApp, transcribes content, and generates intelligent responses using GPT. Built with FastAPI, AWS Lambda, and LangChain, it delivers seamless real-time conversations.",
			logo: "https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg",
			linkText: "View Project",
			link: "https://www.notion.so/AI-Powered-Whatsapp-Bot-25f8329208d7804f9804e6894b7eeaec?source=copy_link",
		},
		{
			title: "Smart Invoice Processing API",
			description:
				"An OCR-powered software capable of extracting and structuring data from any invoice in under 2 seconds. Leveraging FastAPI, Google Vision, Groq  and advanced PDF parsing, it enables lightning-fast, reliable, and scalable financial automation.",
			logo: "https://upload.wikimedia.org/wikipedia/commons/3/38/SQLite370.svg",
			linkText: "View Project",
			link: "https://github.com/AryamanSi17/Invoice-Processing-API",
		}

	],
};

export default INFO;
